// src/resources/posts.ts
export type ResourcePost = {
  title: string;
  slug: string; // must match ResourcesRouter route path
  description: string;
  date: string; // ISO date string for sorting (newest first)
  category?: string;
  readTime?: string;
  thumbnail?: string;
  author?: string;
};

// Update/add posts here. Make sure slug matches the route path.
export const posts: ResourcePost[] = [
  {
    title: "Construction Contractor Tax Guide: 1099 Tax Deductions & Tips (2025)",
    slug: "construction-contractor-tax-guide",
    description:
      "Complete tax guide for construction contractors covering deductions, quarterly taxes, equipment write-offs, and industry-specific tips.",
    date: "2024-10-15",
    category: "Industry Guides",
    readTime: "12 min read",
    thumbnail: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&auto=format&fit=crop&q=80",
    author: "Free1099Calc Team",
  },
  {
    title: "How to Calculate What You Owe as a 1099 Contractor",
    slug: "how-to-calculate-what-you-owe-1099",
    description:
      "Step-by-step guide to estimate your federal, state, and self-employment taxes accurately as a 1099 earner.",
    date: "2024-10-10",
    category: "Tax Planning",
    readTime: "8 min read",
    thumbnail: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=800&auto=format&fit=crop&q=80",
    author: "Free1099Calc Team",
  },
  {
    title: "Do You Need to Pay Quarterly Taxes?",
    slug: "do-you-need-to-pay-quarterly-taxes",
    description:
      "When quarterly estimated taxes apply, how penalties work, and how to plan your payments.",
    date: "2024-10-05",
    category: "Quarterly Taxes",
    readTime: "6 min read",
    thumbnail: "https://images.unsplash.com/photo-1450101215322-bf5cd27642fc?w=800&auto=format&fit=crop&q=80",
    author: "Free1099Calc Team",
  },
  {
    title: "Home Office Deductions for 1099 Workers",
    slug: "home-office",
    description:
      "What qualifies as a home office and how to choose between simplified vs. regular method.",
    date: "2024-10-01",
    category: "Tax Deductions",
    readTime: "7 min read",
    thumbnail: "https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=800&auto=format&fit=crop&q=80",
    author: "Free1099Calc Team",
  },
  {
    title: "HSA Deductions for 1099 Workers",
    slug: "hsa-deductions",
    description: "Eligibility, 2024 contribution limits, and how HSAs reduce your taxable income.",
    date: "2024-09-25",
    category: "Tax Deductions",
    readTime: "5 min read",
    thumbnail: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&auto=format&fit=crop&q=80",
    author: "Free1099Calc Team",
  },
  {
    title: "Mileage Deduction Rules for 1099 Contractors",
    slug: "mileage-deduction",
    description: "Standard mileage rate vs. actual expenses, and simple tracking tips.",
    date: "2024-09-20",
    category: "Tax Deductions",
    readTime: "6 min read",
    thumbnail: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800&auto=format&fit=crop&q=80",
    author: "Free1099Calc Team",
  },
  {
    title: "Who Should Use a 1099 Calculator?",
    slug: "who-should-use-1099-calculator",
    description: "Freelancers, gig workers, and small business owners benefit most—here's why.",
    date: "2024-09-15",
    category: "Getting Started",
    readTime: "4 min read",
    thumbnail: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&auto=format&fit=crop&q=80",
    author: "Free1099Calc Team",
  },
  {
    title: "What Is the QBI Deduction? Guide for 1099 Workers",
    slug: "what-is-qbi",
    description:
      "A plain-English explainer of the Qualified Business Income (QBI) deduction for pass-through businesses.",
    date: "2024-09-10",
    category: "Tax Deductions",
    readTime: "9 min read",
    thumbnail: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&auto=format&fit=crop&q=80",
    author: "Free1099Calc Team",
  },
  {
    title: "S-Corp vs. Sole Proprietor: When to Make the Switch",
    slug: "s-corp-vs-sole-prop",
    description:
      "Pros and cons, taxes, and when an S-Corp might make sense compared to a sole proprietorship.",
    date: "2024-09-05",
    category: "Business Structure",
    readTime: "10 min read",
    thumbnail: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=800&auto=format&fit=crop&q=80",
    author: "Free1099Calc Team",
  },
  {
    title: "Simple Bookkeeping for 1099 Contractors",
    slug: "simple-bookkeeping-1099",
    description: "A lightweight system to categorize revenue and expenses so tax time is painless.",
    date: "2024-09-01",
    category: "Bookkeeping",
    readTime: "7 min read",
    thumbnail: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&auto=format&fit=crop&q=80",
    author: "Free1099Calc Team",
  },
];
